// 広告設定データ
export const adConfigs = [
  {
    id: 'ad1',
    name: 'A8.net広告1',
    linkUrl: 'https://px.a8.net/svt/ejp?a8mat=45BJND+AS6N76+1WP2+1BNBJL',
    imageUrl: 'https://www27.a8.net/svt/bgt?aid=250801465652&wid=001&eno=01&mid=s00000008903008003000&mc=1',
    trackingUrl: 'https://www13.a8.net/0.gif?a8mat=45BJND+AS6N76+1WP2+1BNBJL',
    width: 300,
    height: 250
  },
  {
    id: 'ad2',
    name: 'A8.net広告2',
    linkUrl: 'https://px.a8.net/svt/ejp?a8mat=45BZ6J+1NJD9U+4EKC+639IP',
    imageUrl: 'https://www20.a8.net/svt/bgt?aid=250821595100&wid=001&eno=01&mid=s00000020550001023000&mc=1',
    trackingUrl: 'https://www11.a8.net/0.gif?a8mat=45BZ6J+1NJD9U+4EKC+639IP',
    width: 300,
    height: 250
  },
  {
    id: 'ad3',
    name: 'A8.net広告3',
    linkUrl: 'https://px.a8.net/svt/ejp?a8mat=45BZ6J+1JYRN6+3AQG+ZRALD',
    imageUrl: 'https://www25.a8.net/svt/bgt?aid=250821595094&wid=001&eno=01&mid=s00000015388006006000&mc=1',
    trackingUrl: 'https://www15.a8.net/0.gif?a8mat=45BZ6J+1JYRN6+3AQG+ZRALD',
    width: 300,
    height: 250
  }
];

/**
 * ランダムに広告設定を選択する
 * @returns {Object} 選択された広告設定
 */
export const getRandomAd = () => {
  const randomIndex = Math.floor(Math.random() * adConfigs.length);
  return adConfigs[randomIndex];
};